import { useResourcesStore } from '../stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import type { ResourceItem } from 'vince-core/types/common';
import { getTablesList } from 'vince-core/api/tables';
import { loadUsers } from 'vince-core/api/users';
import { loadRoles } from 'vince-core/api/roles';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource('CUSTOM_TABLE', 'menus.submenus.tableManagement', [Action.WRITE, Action.READ], async () => {
        return await getTablesList().then((tables) => {
            return tables.items.map((it) => {
                return {
                    id: it.tableName,
                    key: it.tableName,
                    label: it.tableAlias,
                    description: it.description,
                    resourceType: 'CUSTOM_TABLE',
                    usable: !it.toBeDeleted
                } as ResourceItem;
            });
        });
    }, 'pi pi-table');

    store.registerResource('USER', 'menus.submenus.users', [Action.WRITE, Action.READ], async () => {
        return await loadUsers().then((users) => {
            return users.items.map((it) => {
                return {
                    id: it.userId,
                    key: it.userId,
                    label: it.firstName + ' ' + it.lastName,
                    description: it.email,
                    resourceType: 'USER',
                    usable: true
                } as ResourceItem;
            });
        });
    }, 'pi pi-user');

    store.registerResource('ROLE', 'common.roles', [Action.WRITE, Action.READ], async () => {
        return await loadRoles().then((roles) => {
            return roles.items.map((it) => {
                return {
                    id: it.roleId,
                    key: it.roleId,
                    label: it.roleName,
                    description: it.description,
                    resourceType: 'ROLE',
                    usable: true
                } as ResourceItem;
            });
        });
    }, 'pi pi-users');
});
